<template>
  <div>
    <account-list-add-new
      :is-add-new-account-sidebar-active.sync="isAddNewAccountSidebarActive"
      :category-options="categoryOptions"
      :bank-options="bankList"
    />

    <b-card no-body class="mb-0">
      <div class="m-2">
        <b-row>
          <!-- Search -->
          <b-col cols="12" md="12">
            <div
              v-bind:class="{
                'align-items-center justify-content-end': isActive,
                'd-flex align-items-center justify-content-end': !isActive,
              }"
            >
              <b-input-group class="mr-1">
                <b-form-input
                  v-model="searchQuery"
                  @keyup.enter="searchWord()"
                  :placeholder="$t('message.bookmark.search')"
                />
                <b-input-group-append>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon"
                    @click="searchWord()"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-button
                variant="outline-primary"
                class="btn-icon mr-1"
                :to="{ name: 'apps-chart-accounts' }"
              >
                <feather-icon icon="PieChartIcon" />
              </b-button>
              <br v-if="isActive" />
              <b-dropdown
                right
                variant="gradient-warning"
                class="mr-1"
                v-if="restrictions('button_export_data')"
              >
                <template slot="button-content">
                  <feather-icon icon="DownloadIcon" />
                </template>
                <b-dropdown-item
                  ><download-excel
                    :data="accountList"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                    :name="$t('message.buttons.dataInView')"
                  >
                    {{ $t("message.buttons.dataInView") }}
                  </download-excel></b-dropdown-item
                >
                <b-dropdown-item
                  ><download-excel
                    :fetch="allData"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                    :name="$t('message.buttons.allData')"
                  >
                    {{ $t("message.buttons.allData") }}
                  </download-excel></b-dropdown-item
                >
              </b-dropdown>

              <!--<b-button class="mr-1" variant="secondary" v-b-modal.modal-import>
                <span class="text-nowrap">Importar dados</span>
              </b-button>-->

              <b-button
                variant="primary"
                @click="isAddNewAccountSidebarActive = true"
                v-if="restrictions('button_new_account')"
              >
                <span class="text-nowrap">{{
                  $t("message.accounts.newAccount")
                }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        id="my-table"
        ref="refaccountListTable"
        class="position-relative"
        :items="accountList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :busy="isBusy"
        show-empty
        @row-clicked="openViewPage"
        hover
      >
        <template #table-busy>
          <div class="text-center my-17">
            <b-spinner class="align-middle"></b-spinner>
            <strong> {{ $t("message.load") }}</strong>
          </div>
        </template>

        <template slot="empty">
          <div class="text-center my-5">
            {{ $t("message.registerNotFound") }}
          </div>
        </template>

        <template #cell(date)="data">
          {{ localeDate(data.item.date) }}
        </template>

        <template #cell(description)="data">
          <span v-html="data.item.description"></span>
        </template>

        <template #cell(value)="data">
          {{ $n(data.item.value, "currency") }}
        </template>

        <template #cell(bankAccount)="data">
          {{ validAccount(data.item.bankAccount) }}
        </template>

        <template #cell(category)="data">
          {{ data.item.category }}
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("message.pagelength") }} {{ dataMeta.from }}
              {{ $t("message.of") }} {{ dataMeta.to }} {{ $t("message.of") }}
              {{ totalRegisters }} {{ $t("register") }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            v-if="showPagination"
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRegisters"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              aria-controls="my-table"
              @input="eventPage(currentPage)"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-import"
      modal-class="modal-primary"
      centered
      title="Importar arquivo"
      hide-footer
    >
      <b-card-text> Arraste ou selecione os arquivo</b-card-text>

      <b-form-file
        id="wildcard"
        ref="file-input"
        class="mr-1"
        v-model="file"
        browse-text="Procurar"
        placeholder="Nenhum arquivo selecionado"
        drop-placeholder="Arraste arquivo aqui"
        @change="onChange"
      >
      </b-form-file>

    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BSpinner,
  BFormFile,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useaccountsList from "./useAccountsList";
import AccountListAddNew from "./AccountListAddNew.vue";
import axios from "@axios";
import URL_API from "@core/utils/env";
import getHeader from "@core/utils/auth";
import moment from "moment";
import Ripple from "vue-ripple-directive";
import JsonExcel from "vue-json-excel";
import Vue from "vue";
import AccessControl from "@core/utils/access-control";
import ListWidth from "@core/utils/listWidth";
import store from "@/store";
import readXlsxFile from 'read-excel-file'

Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    AccountListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BSpinner,
    BFormFile,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      accountList: [],
      totalRegisters: 0,
      perPage: 0,
      currentPage: 1,
      isBusy: false,
      showPagination: true,
      allDataSize: 9999,

      //Param
      paramData: store.state.user.paramData,
      userData: store.state.user.userData,

      //Resize
      windowWidth: window.innerWidth,
      isActive: true,

      bankList: [],
      categoryOptions: [],

      file: null,
    };
  },

  computed: {
    tableColumns() {
      const lang = this.$i18n.locale;
      if (!lang) {
        return [];
      }

      return [
        { key: "date", sortable: false, label: this.getColLabel("date") },
        {
          key: "description",
          sortable: false,
          label: this.getColLabel("desc"),
        },
        { key: "value", sortable: false, label: this.getColLabel("valor") },
        {
          key: "bankAccount",
          sortable: false,
          label: this.getColLabel("bankAccount"),
        },
        {
          key: "category",
          sortable: false,
          label: this.getColLabel("category"),
        },
      ];
    },
  },

  async created() {
    this.onResize();
    this.getAccountList();

    var bankList = [];
    var bankId = [];
    await axios
      .get(`${URL_API}bank/options`, {
        headers: getHeader(this.userData),
      })
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i].name;
          const id = response.data[i].id;
          bankList.push(element);
          bankId.push(id);
          this.bankList.push({
            label: bankList[i],
            value: bankId[i],
          });
        }
      });

    var category = [];
    await axios
      .get(`${URL_API}account_categories`, {
        headers: getHeader(this.userData),
      })
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i].category;
          category.push(element);
          this.categoryOptions.push({
            label: category[i],
            value: category[i],
          });
        }
      });
  },

  mounted() {
    this.$root.$on("newListAccount", (newListAccount) => {
      this.isBusy = true;

      axios
        .get(
          `${URL_API}account/list?page=0&sort=id,${this.paramData.listSort}&size=${this.paramData.tableSize}`,
          {
            headers: getHeader(this.userData),
          }
        )
        .then((response) => {
          this.accountList = response.data.content;
          this.totalRegisters = response.data.totalElements;
          this.perPage = response.data.numberOfElements;
          this.currentPage = 1;
          this.isBusy = false;
        });
    });

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    async allData() {
      const response = await axios.get(
        `${URL_API}account/list?page=0&sort=id,${this.paramData.listSort}&size=${this.allDataSize}`,
        { headers: getHeader(this.userData) }
      );
      return response.data.content;
    },

    onChange(event) {

      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {

        const reader = new FileReader();
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        }
        reader.readAsBinaryString(this.file);
      }
    },

    validAccount(value) {
      if (value != undefined) {
        for (var i = 0; i < this.bankList.length; i++) {
          if (value === this.bankList[i].value) {
            return this.bankList[i].label;
          }
        }
      } else {
        return "Não atribuído";
      }
    },

    onResize() {
      this.windowWidth = window.innerWidth;
      this.isActive = ListWidth(this.windowWidth);
    },

    getColLabel(colName) {
      return this.$i18n.t("message.accounts." + colName);
    },

    openViewPage(row) {
      row._showDetails = !row._showDetails;
      this.$router.push({ name: "apps-account-view", params: { id: row.id } });
    },

    restrictions(value) {
      return AccessControl(value);
    },

    startDownload() {
      this.isBusy = true;
    },

    finishDownload() {
      this.isBusy = false;
    },

    formattedType(type) {
      if (type === "isolate") {
        return "Isolado";
      }
      return "Recorrente";
    },

    formattedDay(day) {
      if (!day) {
        return "---";
      }

      return day;
    },

    async getAccountList() {
      this.isBusy = true;
      await axios
        .get(
          `${URL_API}account/list?page=0&sort=id,${this.paramData.listSort}&size=${this.paramData.tableSize}`,
          {
            headers: getHeader(this.userData),
          }
        )
        .then((response) => {
          this.totalRegisters = response.data.totalElements;
          this.accountList = response.data.content;
          this.perPage = response.data.numberOfElements;
          this.isBusy = false;
        });

      if (this.accountList === null) {
        this.showPagination = false;
      } else {
        this.showPagination = true;
        this.currentPage = 1;
      }
    },

    async eventPage(currentPage) {
      this.isBusy = true;
      await axios
        .get(
          `${URL_API}account/list?page=${currentPage - 1}&sort=id,${
            this.paramData.listSort
          }&size=${this.paramData.tableSize}`,
          {
            headers: getHeader(this.userData),
          }
        )
        .then((response) => {
          this.accountList = response.data.content;
          this.isBusy = false;
        });

      if (this.accountList === null) {
        this.showPagination = false;
      } else {
        this.showPagination = true;
      }
    },

    async getAccountFilter() {
      this.isBusy = true;
      await axios
        .get(`${URL_API}account/search?searchTerm=${this.searchQuery}`, {
          headers: getHeader(this.userData),
        })
        .then((response) => {
          this.accountList = [];
          if (response.data != []) {
            for (var i = 0; i < response.data.length; i++) {
              this.accountList.push(response.data[i]);
            }
          }
          this.isBusy = false;
          this.showPagination = false;
        });
    },

    searchWord() {
      if (this.searchQuery) {
        this.getAccountFilter();
      } else {
        this.getAccountList();
      }
    },

    localeDate(value) {
      if (value) {
        return this.$i18n.d(
          new Date(value.split("-")),
          "short",
          this.$i18n.locale
        );
      }
      return this.$i18n.t("message." + "noDate");
    },
  },

  setup() {
    const isAddNewAccountSidebarActive = ref(false);

    const {
      perPage,
      currentPage,
      totalaccounts,
      dataMeta,
      searchQuery,
      refaccountListTable,
    } = useaccountsList();

    return {
      isAddNewAccountSidebarActive,
      perPage,
      currentPage,
      totalaccounts,
      dataMeta,
      searchQuery,
      refaccountListTable,
      avatarText,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.my-17 {
  margin-top: 17.2rem;
  margin-bottom: 17.2rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
